export const maxAutocompletePageSize = 100;
export const apiHost = process.env.REACT_APP_API_HOST;
export const httpProtocol = apiHost.includes("localhost")
  ? "http://"
  : "https://";
export const wsProtocol = apiHost.includes("localhost") ? "ws://" : "wss://";
export const apiOrigin = httpProtocol + apiHost;
export const wsOrigin = wsProtocol + apiHost;
